(function($) {
    class W4D_MyAccount {
        constructor() {
            this.initSelectors()
            this.bindEvents();
            this.initShippingFields();
        }

        initSelectors() {
            // Password reset selectors
            this.passwordResetForm = $('#password-reset-form');
            this.passwordResetSave = $('#password-reset__save');
            this.oldPassword = this.passwordResetForm.find('#old_password');
            this.newPassword = this.passwordResetForm.find('#new_password');
            this.repeatPassword = this.passwordResetForm.find('#repeat_password');

            this.formRequirements = $('.form__requirements');
            this.requirements = {
                length: this.formRequirements.find('li:nth-child(1) i'),
                lowercase: this.formRequirements.find('li:nth-child(2) i'),
                uppercase: this.formRequirements.find('li:nth-child(3) i'),
                number: this.formRequirements.find('li:nth-child(4) i'),
                specialChar: this.formRequirements.find('li:nth-child(5) i'),
                matchingPassowrds: this.formRequirements.find('li:nth-child(6) i')
            };

            // Account info selectors
            this.accountInfoForm = $('.form--account-info');
            this.accountInfoSave = $('#my-account__save');
            this.shipToDifferentCheckbox = $('#ship-to-different-address-checkbox');
            this.shippingFields = $('.shipping-fields-container');

            // Repeat Order Action
            this.repeatOrderElement = $('.repeat-order-action');

            // IOS
            this.ios = $('.ios');
            this.iosClose = this.ios.find('.js-close');
        }

        bindEvents() {
            // Password reset events
            this.passwordResetForm.on('input', 'input', () => this.updateSubmitButtonState());
            this.passwordResetSave.on('click', (e) => this.handlePasswordChangeSubmit(e));
            this.newPassword.on('input', (e) => this.checkPasswordRequirements($(e.target).val()));
            this.repeatPassword.on('input', (e) => {
                this.validateRepeatPassword($(e.target));
                this.checkPasswordRequirements(this.newPassword.val());
            });

            // Account info events
            this.shipToDifferentCheckbox.on('change', () => this.toggleShippingFields());
            this.accountInfoSave.on('click', (e) => this.handleAccountInfoSubmit(e));

            this.repeatOrderElement.on('click', (e) => this.handleRepeatOrderAction(e));

            // Dugovanje
            this.iosClose.on('click', (e) => this.closeIos(e));
        }

        closeIos() {
            this.ios.addClass('ios--hide');
        }

        // ---------------------------------------->> ACCOUNT INFO METHODS <<----------------------------------------||
        initShippingFields() {
            this.toggleShippingFields();
        }

        toggleShippingFields() {
            if (this.shipToDifferentCheckbox.is(':checked')) {
                this.shippingFields.slideDown(300);
            } else {
                this.shippingFields.slideUp(300);
            }
        }

        validateEmail(inputElement) {
            if (!inputElement || !inputElement.length) {
                console.error('Input element not found');
                return false;
            }
            const value = inputElement.val().trim();
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const isValid = emailRegex.test(value);

            if (value === '') {
                this.showErrorMessage(inputElement, 'Email adresa je obavezna');
                inputElement.removeClass('form__input-success');
                return false;
            } else if (!isValid) {
                this.showErrorMessage(inputElement, 'Nevažeća email adresa');
                inputElement.removeClass('form__input-success');
                return false;
            } else {
                this.removeErrorMessage(inputElement);
                inputElement.addClass('form__input-success');
                return true;
            }
        }

        showErrorMessage(inputElement, message) {
            let errorSpan = inputElement.siblings('.error-message');
            if (!errorSpan.length) {
                errorSpan = $('<span class="error-message"></span>');
                inputElement.after(errorSpan);
            }
            errorSpan.text(message);
            inputElement.addClass('error');
        }

        removeErrorMessage(inputElement) {
            inputElement.siblings('.error-message').remove();
            inputElement.removeClass('error');
        }

        handleAccountInfoSubmit(e) {
            e.preventDefault();

            const billingEmailValid = this.validateEmail($('#billing_email'));

            if (!billingEmailValid) {
                return;
            }

            const formData = new FormData();

            this.accountInfoForm.find('input').each(function() {
                formData.append(this.name, this.value);
            });

            formData.append('ship_to_different_address', this.shipToDifferentCheckbox.is(':checked'));
            formData.append('action', 'update_customer_data');
            formData.append('nonce', w4d_frontend_ajax.nonce);

            $.post({
                url: w4d_frontend_ajax.ajax_url,
                data: formData,
                processData: false,
                contentType: false,
                beforeSend: () => {
                    this.accountInfoSave.prop('disabled', true).text('Spremanje...');
                },
                success: (response) => {
                    if (response.success) {
                        $('#billing_email').removeClass('form__input-success');
                        W4D_FrontendHelper.showNotice('success', 'Podaci su uspješno spremljeni');
                    } else {
                        W4D_FrontendHelper.showNotice('error', 'Došlo je do greške prilikom spremanja');
                    }
                },
                error: () => {
                    W4D_FrontendHelper.showNotice('error', 'Došlo je do greške prilikom spremanja');
                },
                complete: () => {
                    this.accountInfoSave.prop('disabled', false).text('Spremi promjene');
                }
            });
        }

        checkPasswordRequirements(password) {
            const requirements = {
                length: password.length >= 8,
                lowercase: /[a-z]/.test(password),
                uppercase: /[A-Z]/.test(password),
                number: /[0-9]/.test(password),
                specialChar: /\W/.test(password),
                matchingPassowrds: this.newPassword.val() === this.repeatPassword.val()
            };

            Object.entries(requirements).forEach(([key, isMet]) => {
                this.updateRequirement(this.requirements[key], isMet);
            });

            this.newPassword.toggleClass('form__input-success', Object.values(requirements).every(Boolean));
        }

        updateRequirement(requirementIcon, isMet) {
            requirementIcon.toggleClass('icon-checkmark', isMet).toggleClass('icon-x-rounded', !isMet);
        }

        updateSubmitButtonState() {
            const isPasswordValid = this.newPassword.hasClass('form__input-success');
            const isRepeatPasswordValid = this.validateRepeatPassword();
            const isOldPasswordValid = this.oldPassword.val().trim() !== ''; // Add this line
            const isFormValid = isPasswordValid && isRepeatPasswordValid && isOldPasswordValid; // Add oldPassword check

            this.passwordResetSave.prop('disabled', !isFormValid)
                .parent().toggleClass('form__input--submit-disabled', !isFormValid);
        }

        clearForm() {
            this.oldPassword.val('');
            this.newPassword.val('');
            this.repeatPassword.val('');
        }

        validateRepeatPassword() {
            const isValid = this.repeatPassword.val() === this.newPassword.val() && this.repeatPassword.val() !== '';
            this.repeatPassword.toggleClass('form__input-success', isValid);

            if (this.repeatPassword.val() !== '' && !isValid) {
                this.repeatPassword.toggleClass('error');
            }

            return isValid;
        }

        handlePasswordChangeSubmit(e) {
            e.preventDefault();

            const ajaxData = {
                action: 'w4d_change_password',
                old_password: this.oldPassword.val(),
                new_password: this.newPassword.val(),
                nonce: w4d_frontend_ajax.nonce
            }

            $.post({
                url: w4d_frontend_ajax.ajax_url,
                data: ajaxData,
                success: (response) => {
                    if (response.success) {
                        W4D_FrontendHelper.showNotice('success', 'Uspješno promijenjena lozinka.');
                        this.clearForm();
                    } else {
                        W4D_FrontendHelper.showNotice('error', response.data.message);
                    }
                },
                error: () => {
                    W4D_FrontendHelper.showNotice('error', 'Došlo je do greške. Pokušajte ponovno.');
                }
            });
        }

        handleRepeatOrderAction(e){
            e.preventDefault();

            let orderNumber = $(e.target).data('order-number');

            const ajaxData = {
                action: 'w4d_add_order_items_to_cart',
                order_number: orderNumber,
                nonce: w4d_frontend_ajax.nonce
            }

            $.post({
                url: w4d_frontend_ajax.ajax_url,
                data: ajaxData,
                success: (response) => {
                    if (response.success) {
                        W4D_FrontendHelper.showNotice('success', 'Stavke narudžbe #' + orderNumber + ' uspješno dodane u košaricu.');
                        W4D_FrontendHelper.updateCartIcon(response.data.cart_count);
                    } else {
                        W4D_FrontendHelper.showNotice('error', response.data.message);
                    }
                },
                error: () => {
                    W4D_FrontendHelper.showNotice('error', 'Došlo je do greške. Pokušajte ponovno.');
                }
            });
        }
    }

    $(document).ready(function() {
        new W4D_MyAccount();
    });
})(jQuery);